module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00547.35de435e.jpg";